import {Injectable} from '@angular/core';
import {Subscription} from 'rxjs';
import {distinctUntilChanged, skip} from 'rxjs/operators';
import {DeviceService} from '@mydocma/core/src/lib/device';
import {ScreenOrientationEnum, ScreenOrientationService} from '@mydocma/core';

const FAULT_PANE_SELECTOR = '.cdk-overlay-pane.mydocma-mm-fault-pane-dialog';
const PORTRAIT_OFFSET_PX = 280;
const LANDSCAPE_OFFSET_PX = 104;

// Android resizes the WebView frame from the bottom when the soft keyboard opens (no page pan), so the
// fault dialog height frozen at open time (calc(100vh - offset)) is wrong after a rotation and the focused
// field can end up behind the keyboard. Only on rotation while the dialog is open: re-apply the
// orientation-correct offset and reveal the focused field. Nothing runs on plain keyboard open/close.
@Injectable({providedIn: 'root'})
export class MmAndroidKeyboardDialogFitService {

  private orientationSubscription: Subscription | null = null;

  constructor(
    private readonly deviceService: DeviceService,
    private readonly screenOrientationService: ScreenOrientationService,
  ) {}

  start(): void {
    if (this.orientationSubscription || typeof window === 'undefined') {
      return;
    }
    this.orientationSubscription = this.screenOrientationService.currentScreenOrientation$
      .pipe(distinctUntilChanged(), skip(1))
      .subscribe(orientation => this.onRotate(orientation));
  }

  private onRotate(orientation: ScreenOrientationEnum): void {
    const pane = document.querySelector(FAULT_PANE_SELECTOR) as HTMLElement | null;
    if (!pane) {
      return;
    }
    const offset = (this.deviceService.isTablet() && orientation === ScreenOrientationEnum.portrait) ? PORTRAIT_OFFSET_PX : LANDSCAPE_OFFSET_PX;
    pane.style.height = `calc(100vh - ${offset}px)`;
  }
}
